import { Button, Empty, Pagination } from 'antd';
import classNames from 'classnames';
import { API_STATUS } from 'constants/constants';
import { size } from 'lodash';
import React from 'react';
import Loading from './Loading';

const getTextDescPagination = ({ skip = 0, total = 0 }, current = 0) => {
  return `${total > 0 ? skip + 1 : 0} - ${skip + current} of ${total}`;
};

const Page = ({
  status,
  data,
  title,
  onCreate,
  renderSearch,
  renderList,
  currentPage,
  onChangePage,
  meta = {},
  pageSize = 10,
  pageClass,
}) => {
  return (
    <div
      className={classNames('page-container', {
        [pageClass]: pageClass,
      })}
    >
      {status === API_STATUS.PROCESSING && <Loading />}
      <div className="page-container__body">
        <div className="page-container__header">
          <div className="page-container__title">{title}</div>
          {onCreate && (
            <div className="page-container__create">
              <Button onClick={onCreate} type="primary">
                Create New
              </Button>
            </div>
          )}
        </div>
        <div className="page-container__search">
          {renderSearch && renderSearch()}
        </div>
        {size(data) > 0 ? (
          <div className="page-container__list">{renderList()}</div>
        ) : (
          <Empty description={false} />
        )}
        <div className="page-container__footer">
          <span className="desc">
            {getTextDescPagination(meta, size(data))}
          </span>
          <Pagination
            showSizeChanger={false}
            current={currentPage}
            onChange={onChangePage}
            total={meta.total || 0}
            pageSize={pageSize}
          />
        </div>
      </div>
    </div>
  );
};

export default Page;
